import { PageHeader, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import TfTable from '../TimeframeAdmin/TfTable';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import TfItemForm from '../TimeframeAdmin/TfItemForm';
import { SubHeading, Title } from 'components/RevxTypography';
import React, { useMemo } from 'react';
import {
  EMPTY_SCHEDULE,
  GenericSchedule,
  ScheduleTypeEnum,
} from 'domains/tfDomain';
import RevxFlexLayout from 'components/RevxFlexLayout';
import { RevxButton } from 'components/RevxButton';
import { absPathRender } from 'utils/misc';
import { useParentEqpt } from './useParentEqpt';

const EqptTfAdmin = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const parentEqpt = useParentEqpt();

  const curItem = useAppSelector((state) => state.tf.curItem);

  const genericDefaults = useMemo(() => {
    return (
      parentEqpt?.defaultTurnaroundTimes?.map(
        (t) =>
          ({
            ...t,
            parentId: parentEqpt.id,
            parentType: 'eqpt',
          } as GenericSchedule)
      ) || []
    );
  }, [parentEqpt]);
  const genericExceptions = useMemo(() => {
    return (
      parentEqpt?.exceptionTurnaroundTimes?.map(
        (t) =>
          ({
            ...t,
            parentId: parentEqpt.id,
            parentType: 'eqpt',
          } as GenericSchedule)
      ) || []
    );
  }, [parentEqpt]);

  const onDefaultsAdd = () => {
    dispatch.tf.setState({
      curItem: {
        ...EMPTY_SCHEDULE,
        type: ScheduleTypeEnum.DEFAULT,
        parentId: parentEqpt!.id,
        parentType: 'eqpt',
      },
    });
  };
  const onExceptionsAdd = () => {
    dispatch.tf.setState({
      curItem: {
        ...EMPTY_SCHEDULE,
        type: ScheduleTypeEnum.EXCEPTION,
        parentId: parentEqpt!.id,
        parentType: 'eqpt',
      },
    });
  };

  const routes = [
    {
      path: 'platform/eqpt',
      breadcrumbName: parentEqpt?.name || t('platform.platformMenu.eqpt'),
    },
    {
      path: '',
      breadcrumbName: t('platform.platformMenu.tf'),
    },
  ];

  return (
    <>
      <PageHeader
        ghost={false}
        breadcrumb={{ routes, itemRender: absPathRender }}
        // extra={[
        //   <RevxButton
        //     key="create"
        //     type="primary"
        //     onClick={() => {
        //     }}
        //   >
        //     {t('platform.tf.labels.testButton')}
        //   </RevxButton>,
        // ]}
      />
      <Space direction="vertical" style={{ width: '100%' }}>
        <Title>{t('platform.tf.labels.defaultSectionTitle')}</Title>
        <RevxFlexLayout justify="space-between">
          <SubHeading>
            {t('platform.tf.labels.defaultSectionSubTitleOrg')}
          </SubHeading>
          <RevxButton
            key="createDefault"
            type="primary"
            onClick={onDefaultsAdd}
            size="middle"
          >
            {t('common.create')}
          </RevxButton>
        </RevxFlexLayout>
        <TfTable
          data={genericDefaults}
          onItemView={(record) => dispatch.tf.setState({ curItem: record })}
        />
        <Title>{t('platform.tf.labels.exceptionSectionTitle')}</Title>
        <RevxFlexLayout justify="space-between">
          <SubHeading>
            {t('platform.tf.labels.exceptionSectionSubTitle')}
          </SubHeading>
          <RevxButton
            key="createException"
            type="primary"
            onClick={onExceptionsAdd}
          >
            {t('common.create')}
          </RevxButton>
        </RevxFlexLayout>
        <TfTable
          data={genericExceptions}
          onItemView={(record) => dispatch.tf.setState({ curItem: record })}
        />

        {curItem && <TfItemForm />}
      </Space>
    </>
  );
};

export default EqptTfAdmin;
